import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import SearchOutlined from "@mui/icons-material/SearchOutlined";
// import { Tooltip, IconButton } from "@mui/material";
import moment from "moment";
import "./Telemarketing.css";
import AssignmentDetails from "../Campaign/AssignmentDetails";
import CampaignDetails from "../Campaign/CampaignDetails";
import Loader from "../Components/Loader";
import { setMakeCall } from "../Store/Actions/CallAction";

import {
  checkCampaignAutoDial,
  getAssignmentAutoDial,
  getCampaignList,
} from "../Store/Actions/OutboundAction";

import {
  SET_AUTO_DIAL,
  SET_AUTO_DIAL_CAMPAIGN,
  SET_DIAL_MODE,
  SET_LAST_ASSIGNMENTID,
} from "../Store/Types/AgentTypes";

import { SET_NEXT_ASSIGNMENT } from "../Store/Types/CallTypes";
import { SET_CURRENT_ASSIGNMENT_ID } from "../Store/Types/OutboundTypes";

export default function Telemarketing({ GenerateNonPopUpFiles }) {
  const { ACWDuration, ACWMode, stateCall } = useSelector(
    (state) => state.call
  );

  const [searchValue, setSearchValue] = useState("");
  const [campaignList, setCampaignList] = useState([]);
  const [filteredCampaignList, setFilteredCampaignList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [selectedCampaign, setSelectedCampaign] = useState(
    stateCall.CampaignID ? stateCall.CampaignID : null
  );

  const [selectedAssignment, setSelectedAssignment] = useState(
    stateCall.AssignmentID ? stateCall.AssignmentID : null
  );

  const [isAutoDialEnabled, setIsAutoDialEnabled] = useState(false);
  const dispatch = useDispatch();

  const {
    lastAssignmentID,
    goToNextAssignment,
    callScheduleAssignmentID,
    autoDialCampaign,
    isAutoDialPaused,
    dialMode,
  } = useSelector((state) => state.agent);

  const { CurrentState, myInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    setIsLoading(true);

    getCampaignList({
      clientid: myInfo.user.ClientID,
      loginid: myInfo.user.AgentID,
      source: 2, // code for TSS
      taskgroupcode: "A",
    })
      .then((response) => {
        if (response.status) {
          setCampaignList(response.data);
          setFilteredCampaignList(response.data);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  }, []);

  // Check campaign auto dial
  useEffect(() => {
    if (
      (selectedCampaign || autoDialCampaign.CampaignID) &&
      !isAutoDialPaused
    ) {
      checkCampaignAutoDial({
        loginID: myInfo.user.AgentID,

        CampaignID: selectedCampaign
          ? selectedCampaign.CampaignID
          : autoDialCampaign.CampaignID,

        Source: 2,
      })
        .then((response) => {
          process.env.NODE_ENV === "development" &&
            console.log("Auto dial: ", response.data.dialmode);

          setIsAutoDialEnabled(response.data.dialmode);

          if (response.data.dialmode) {
            getAssignment();
          }
        })
        .catch((err) => console.log("err", err));
    }
  }, [selectedCampaign]);

  useEffect(() => {
    if (isAutoDialEnabled && !isAutoDialPaused) {
      (selectedCampaign || autoDialCampaign.CampaignID) && getAssignment();
    }
  }, [goToNextAssignment]);

  // To reset selected campaign after outbound transfer. Only runs when not in autodial
  useEffect(() => {
    if (!isAutoDialEnabled && Object.keys(stateCall).length === 0) {
      setSelectedCampaign(null);
    }

    // (JAGADIRI) Get next assignment data for predictive call
    stateCall.AssignmentID &&
      dialMode === "predictive" &&
      setSelectedAssignment(stateCall.AssignmentID);
  }, [stateCall]);

  // Show assignment from call schedule
  useEffect(() => {
    callScheduleAssignmentID && setSelectedAssignment(callScheduleAssignmentID);
  }, [callScheduleAssignmentID]);

  // Get assignment auto dial
  const getAssignment = () => {
    process.env.NODE_ENV === "development" &&
      console.log("selected campaign", selectedCampaign);

    getAssignmentAutoDial({
      agentid: myInfo.user.AgentID,
      // teamid: null,

      campaignid: autoDialCampaign.CampaignID
        ? autoDialCampaign.CampaignID
        : selectedCampaign.CampaignID,

      assignmentid: lastAssignmentID ? lastAssignmentID : 0, // set to 0 if there is no previous assignmentID

      datafilterid:
        autoDialCampaign.DataFilterID || autoDialCampaign.DataFilterID === 0
          ? autoDialCampaign.DataFilterID
          : selectedCampaign.DataFilterID,

      source: 2, // TSS
    })
      .then((response) => {
        if (response.data.phoneno[0].length) {
          process.env.NODE_ENV === "development" &&
            console.log("Next assignment: ", response.data.assignmentid);

          dispatch({
            type: SET_DIAL_MODE,
            payload: "progressive",
          });

          dispatch({ type: SET_AUTO_DIAL, payload: true });
          dispatch({ type: SET_NEXT_ASSIGNMENT, payload: true });

          dispatch({
            type: SET_LAST_ASSIGNMENTID,
            payload: response.data.assignmentid,
          });

          !autoDialCampaign.CampaignID &&
            dispatch({
              type: SET_AUTO_DIAL_CAMPAIGN,
              payload: selectedCampaign,
            });

          setSelectedAssignment(response.data.assignmentid);

          dispatch({
            type: SET_CURRENT_ASSIGNMENT_ID,
            payload: { assignmentID: response.data.assignmentid },
          });

          dispatch(
            setMakeCall({
              phoneNo: selectedCampaign.DialPrefix
                ? selectedCampaign.DialPrefix
                : "" + response.data.phoneno[0][0].Address,

              // Set to READY on continue autodial. Otherwise get current agent status
              agentStatus: autoDialCampaign.CampaignID ? "READY" : CurrentState,
              goToACW: true,
              contactID: response.data.contactid,

              campaignID: autoDialCampaign.CampaignID
                ? autoDialCampaign.CampaignID
                : selectedCampaign.CampaignID,

              phoneTypeID: response.data.phoneno[0][0].AddressTypeID,

              ACWMode: autoDialCampaign.ACWMode
                ? autoDialCampaign.ACWMode
                : selectedCampaign.ACWMode,

              ACWDuration: autoDialCampaign.ACWDuration
                ? autoDialCampaign.ACWDuration
                : selectedCampaign.ACWDuration,

              isTelemarketing: true
            })
          );
        } else {
          // When there are no more assignments, exit auto dial
          dispatch({ type: SET_AUTO_DIAL, payload: false });

          dispatch({
            type: SET_LAST_ASSIGNMENTID,
            payload: null,
          });

          dispatch({
            type: SET_AUTO_DIAL_CAMPAIGN,
            payload: {},
          });

          toast.info("Autodial has stopped. Please check assignment data", {
            autoClose: 3000,
          });
        }
      })
      .catch((err) => {
        console.log("err", err);

        // When there are errors, exit auto dial
        dispatch({ type: SET_AUTO_DIAL, payload: false });

        dispatch({
          type: SET_LAST_ASSIGNMENTID,
          payload: null,
        });

        dispatch({
          type: SET_AUTO_DIAL_CAMPAIGN,
          payload: {},
        });
      });
  };

  return (
    <div className="telemarketing campaign">
      <div className="list_header">
        <div className="list_headerLeft">
          {(selectedAssignment || selectedCampaign) && (
            <Icon
              icon="material-symbols:arrow-back-ios-new-rounded"
              width="32"
              height="32"
              onClick={() => {
                if (selectedAssignment) {
                  setSelectedAssignment(null);
                } else {
                  setSelectedCampaign(null);
                }
              }}
            />
          )}

          <div className="campaign-name">
            <h1>{selectedCampaign ? "Campaign" : "Telemarketing"}</h1>

            {(selectedAssignment || selectedCampaign) && (
              <h2>{selectedCampaign?.Name}</h2>
            )}
          </div>
        </div>
      </div>

      <div className="containerCampaign">
        {selectedAssignment ? (
          <AssignmentDetails
            assignmentID={selectedAssignment}
            setSelectedAssignment={setSelectedAssignment}
            GenerateNonPopUpFiles={GenerateNonPopUpFiles}
            isTelemarketing
            acwMode={selectedCampaign ? selectedCampaign.ACWMode : ACWMode}
            acwDuration={
              selectedCampaign ? selectedCampaign.ACWDuration : ACWDuration
            }
          />
        ) : selectedCampaign ? (
          <CampaignDetails
            setSelectedAssignment={setSelectedAssignment}
            campaignID={selectedCampaign.CampaignID}
            isTelemarketing
          />
        ) : (
          <>
            <div className="container_Header">
              <div className="campaign_search">
                <div className="search-container">
                  <SearchOutlined className="icon" />

                  <input
                    type="search"
                    className="search"
                    placeholder="Search..."
                    value={searchValue}
                    onChange={(e) => {
                      setSearchValue(e.target.value);

                      setFilteredCampaignList(
                        campaignList.filter((campaign) =>
                          campaign.Name.toLowerCase().includes(e.target.value)
                        )
                      );
                    }}
                    onInput={(e) => {
                      if (e.target.value.length === 0) {
                        setFilteredCampaignList(campaignList);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setFilteredCampaignList(
                          campaignList.filter((campaign) =>
                            campaign.Name.toLowerCase().includes(searchValue)
                          )
                        );
                      }
                    }}
                  />
                </div>
              </div>

              {/* <div className="single_button">
                <Tooltip title="Extract sales" arrow placement="left">
                  <IconButton
                    size="medium"
                    onClick={() => setIsExtractSalesDialogShown(true)}
                  >
                    <Icon icon="ph:export-bold" height="26" />
                  </IconButton>
                </Tooltip>
              </div> */}
            </div>

            <div className="container_Body">
              {isLoading ? (
                <Loader />
              ) : (
                <>
                  <section className="list-campaign-groupp">
                    <header>
                      <p>Campaign Name</p>

                      <div className="totals columns">
                        <p>Created</p>
                        {/* <p>Dial Mode</p> */}
                        <p>Total Data</p>
                        <p>New Data</p>
                        <p>TBS</p>
                        <p>Interest</p>
                        <p>Not Interested</p>
                      </div>
                    </header>
                    {filteredCampaignList?.length === 0 ? (
                      <p className="no-campaign">No Campaign Found</p>
                    ) : (
                      filteredCampaignList.map((campaign, index) => {
                        return (
                          <div
                            className="list-campaign-groupp-item"
                            key={index}
                            onClick={() => setSelectedCampaign(campaign)}
                          >
                            <p>{campaign.Name}</p>

                            <div className="totals columns">
                              <p>
                                {moment(campaign.CreatedTime).format("MMMM")}
                              </p>

                              {/* <p>Dial Mode</p> */}
                              <p>{campaign.TotalAllocated}</p>
                              <p>{campaign.NewData}</p>
                              <p>{campaign.TBS}</p>
                              <p>{campaign.Interest}</p>
                              <p>{campaign.NotInterest}</p>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </section>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
